// Sentry initialization must be imported first!
import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "./components/theme/theme-provider";

import { TempoDevtools } from "tempo-devtools";
import { telemetry } from "./telemetry-browser";
import { TelemetryErrorBoundary } from "./components/telemetry/ErrorBoundary";

// Initialize Tempo devtools
TempoDevtools.init();

// Initialize OpenTelemetry
telemetry.init();

// Test telemetry in development
if (import.meta.env.DEV) {
  import('./telemetry-test').then(({ testTelemetry }) => {
    setTimeout(testTelemetry, 1000); // Wait for init to complete
  });
  
  // Debug OTLP connectivity
  import('./debug-otlp');
}

const basename = import.meta.env.BASE_URL;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TelemetryErrorBoundary>
      <ThemeProvider>
        <BrowserRouter basename={basename}>
          <TooltipProvider>
            <App />
          </TooltipProvider>
        </BrowserRouter>
      </ThemeProvider>
    </TelemetryErrorBoundary>
  </React.StrictMode>,
);
